import React, { useEffect, useState } from "react";
import { UserCircle, ShieldCheck, Monitor, LogOut, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/apiClient";

export default function Profile() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/profile").then((r) => setD(r.data)).catch(() => toast.error("Failed"));
  useEffect(() => { load(); }, []);

  const revoke = async (sid) => {
    if (!window.confirm("Revoke this session?")) return;
    try { await api.post("/admin/profile/revoke-session", { session_id: sid }); toast.success("Session revoked"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  if (!d) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-emerald-500" /></div>;
  const p = d.profile;
  const isSuper = p.role === "super_admin";

  return (
    <div className="max-w-3xl space-y-6" data-testid="admin-profile">
      <div className="flex items-center gap-2"><UserCircle className="h-5 w-5 text-emerald-400" /><h1 className="font-heading text-2xl font-bold">Admin profile</h1></div>

      <div className="ledger-card rounded-2xl p-6">
        <div className="flex items-center gap-4">
          <div className="grid h-16 w-16 place-items-center rounded-full bg-emerald-500 font-heading text-2xl font-bold text-slate-950">{(p.name || p.email || "A").charAt(0).toUpperCase()}</div>
          <div>
            <p className="font-heading text-xl font-bold">{p.name || "Admin"}</p>
            <p className="font-mono text-xs text-slate-500">{p.email}</p>
            <span className={`mt-1 inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${isSuper ? "bg-emerald-500/15 text-emerald-400" : "bg-slate-700 text-slate-200"}`}><ShieldCheck className="h-3 w-3" />{isSuper ? "Super Admin" : "Admin"}</span>
          </div>
        </div>
        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <KV k="Status" v={p.status} />
          <KV k="Role" v={p.role} />
          <KV k="Created" v={p.created_at ? new Date(p.created_at).toLocaleDateString("en-IN") : "—"} />
          <KV k="Last login" v={p.last_login ? new Date(p.last_login).toLocaleString("en-IN") : "—"} />
        </div>
      </div>

      <div className="ledger-card overflow-hidden rounded-2xl">
        <div className="flex items-center justify-between p-4">
          <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">Active sessions &amp; login history</p>
          <span className="font-mono text-xs text-slate-500">{d.login_count} sessions</span>
        </div>
        <table className="w-full text-sm" data-testid="profile-sessions-table">
          <thead className="bg-slate-900/50 font-mono text-xs uppercase tracking-wider text-slate-500"><tr><th className="p-4 text-left">Logged in</th><th className="p-4 text-left">Expires</th><th className="p-4"></th></tr></thead>
          <tbody>
            {d.sessions.map((s) => (
              <tr key={s.session_id} className="border-t border-slate-800/60">
                <td className="p-4"><Monitor className="mr-2 inline h-4 w-4 text-slate-500" />{new Date(s.created_at).toLocaleString("en-IN")}{s.current && <span className="ml-2 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-semibold text-emerald-400">CURRENT</span>}</td>
                <td className="p-4 text-slate-400">{s.expires_at ? new Date(s.expires_at).toLocaleDateString("en-IN") : "—"}</td>
                <td className="p-4 text-right">{!s.current && <button data-testid={`revoke-session-${s.session_id}`} onClick={() => revoke(s.session_id)} className="inline-flex items-center gap-1 rounded-full border border-rose-500/40 px-3 py-1 text-xs text-rose-300 hover:bg-rose-500/10"><LogOut className="h-3 w-3" /> Revoke</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function KV({ k, v }) {
  return <div className="rounded-xl border border-slate-800 bg-slate-900/50 p-3"><p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">{k}</p><p className="mt-0.5 text-sm">{v}</p></div>;
}
